import type { MetricCatalogItem } from "@/metrics/configure"

export const findConversationMetric = (
  identifier: string,
  metrics: MetricCatalogItem[],
): MetricCatalogItem | undefined =>
  metrics.find((metric) => metric.id === identifier) ??
  metrics.find((metric) => metric.metric_name === identifier)

export const normalizeConversationMetricIds = (
  identifiers: string[],
  metrics: MetricCatalogItem[],
  requireResolved = false,
): string[] => {
  const normalized = identifiers.map((identifier) => {
    const metric = findConversationMetric(identifier, metrics)
    if (!metric && requireResolved) {
      throw new Error(
        `Selected metric '${identifier}' is unavailable. Reload the metric catalog or remove it before saving.`,
      )
    }
    return metric?.id ?? identifier
  })
  return [...new Set(normalized)]
}
